export default __webpack_public_path__ + "static/media/marcioValenca.345c7338.jpeg";